var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgUserStats = function SvgUserStats(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 20C3.0001 18.8809 3.26765 17.7775 3.78089 16.7798C4.29413 15.782 5.03856 14.918 5.95364 14.2579C6.86872 13.5979 7.92862 13.1605 9.04713 12.9813C10.1656 12.8021 11.3112 12.8862 12.3906 13.2267M12.9 19.8954V17.3333M16.95 19.8954V13.7778M21 19.8954V10.2222M14.7 8.44444C14.7 10.899 12.6853 12.8889 10.2 12.8889C7.71472 12.8889 5.7 10.899 5.7 8.44444C5.7 5.98985 7.71472 4 10.2 4C12.6853 4 14.7 5.98985 14.7 8.44444Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgUserStats);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "user-stats.d61c2d56c0b12b12b72b2a55939ef5e6.svg";